import { useForm } from "@shared/features/form/useForm";
import { Form } from "@shared/features/form/Form";
import { baseProfileSchema } from "@shared/schemas/sharedSchemas";
import { makeFormFields } from "@shared/utils/makeFormFields";
import { useProfileMutation } from "../../hooks/useProfileMutation";
import { User } from "@platform/types/platform.types";
import { ActionButtonsGroup } from "@shared/ui/ActionButtonsGroup";

export type Props = {
  user: User | null;
};

export function SettingsProfileForm({ user }: Props) {
  const schema = baseProfileSchema;

  const fields = makeFormFields([
    "firstName",
    "lastName",
    "photo",
    "pronouns",
    "website",
    "bio",
    "timezone",
    "cv",
    "isEmailNotificationsEnabled",
  ]).map((field) => {
    return { ...field, layout: "horizontal" };
  });

  const onSuccess = (data: any) => {};

  const mutation = useProfileMutation({
    onSuccess,
    schema,
    userRole: user?.role || "",
    previousValues: user,
  });

  const { form, handleSubmit } = useForm({
    schema,
    onSubmit: mutation.mutateAsync,
    defaultValues: user ? ({ ...user, timezone: [user?.timezone] } as any) : {},
  });

  const handleCancel = () => {
    form.reset();
  };

  const { isSubmitting, isLoading, isValid, isDirty } = form.formState;

  return (
    <div className="flex flex-col gap-4 w-full">
      <Form
        fields={fields}
        form={form}
        errorContainerClassName="p-0 w-full max-w-full mt-8"
      />
      <ActionButtonsGroup
        primaryButtonText={"Save Profile"}
        onPrimaryClick={handleSubmit}
        secondaryButtonText={isDirty ? "Cancel" : undefined}
        onSecondaryClick={isDirty ? handleCancel : undefined}
        className="size-max w-fit self-end"
        primaryButtonProps={{
          disabled: !isDirty || !isValid || isSubmitting || isLoading,
        }}
      />
    </div>
  );
}

export default SettingsProfileForm;
